import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import MultivalueDisplay from '../../reports/multivalueDisplayReport/MultivalueDispalyReport';
import ReportPage from '../ReportPage';
import TableReport from '../../reports/tableReport/TableReport';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import FilterPanel, {
  date_range, oem_id, oem_model, sw_version,
} from '../../filters/filterPanel/FilterPanel';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, dailyTransmissionsByDevice, devicesOnlineToday,
  listOfOemModels, listOfOems, listOfSwVersions, totalDatapoints,contractTotalDatapointsTransactions,
} from '../../../services/reportsservice';
import './DeviceUsageAnalysisPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";
import {stringToNumberLocale} from "../../../helpers/formatter";

class DeviceUsageAnalysisPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.DeviceUsageAnalysisPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');

    return {
      filters: [
        listOfOemModels(filters),
        listOfSwVersions(filters),
        listOfOems(filters),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
            activatedDevices(filters),
            contractTotalDatapointsTransactions(filters),
            devicesOnlineToday(filters),
            dailyTransmissionsByDevice(filters),
          ]
          : [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
        dailyTransmissionsByDevice(filters),
      ],
    };
  }

  reportsDescription = () => [
    dailyTransmissionsByDevice(),
  ];

  getAvgDailyTransmissionByDevice = (average_daily_usage_by_device) => {
    let any_device = 0;
    let reg = 0;
    let unreg = 0;
    if (average_daily_usage_by_device) {
      if (average_daily_usage_by_device === t('unableToFetchData')) {
        any_device = reg = unreg = t('unableToFetchData');
      } else if (average_daily_usage_by_device.length) {
        let totalDays = average_daily_usage_by_device.length;
        average_daily_usage_by_device.forEach((average_daily_usage) => {
          any_device += parseInt(average_daily_usage.total_avg) || 0;
          reg += parseInt(average_daily_usage.total_reg) || 0;
          unreg += parseInt(average_daily_usage.total_unreg) || 0;
        });

        any_device = stringToNumberLocale(any_device / totalDays);
        reg = stringToNumberLocale(reg / totalDays);
        unreg = stringToNumberLocale(unreg / totalDays);
      } else {
        any_device = reg = unreg = '0';
      }
    }
    return {
      'devices.anyDevice': {
        type: 'strValue',
        value: any_device
      },
      'devices.registeredDevices': {
        type: 'strValue',
        value: reg
      },
      'devices.unregisteredDevices': {
        type: 'strValue',
        value: unreg
      },
    };
  };

  render() {
    const { fetchData, errors, session } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);
    let average_daily_usage_by_device = getReportData(this.report(dailyTransmissionsByDevice),
      'Daily_Transmissions_By_Device');

    const averageDailyTransmissionByDevice= this.getAvgDailyTransmissionByDevice(average_daily_usage_by_device);

    // custom header rendering for the daily transmission table
    const columnHead = [
      {
        accessor: 'group_day',
        Header: t('axis.group_day'),
      },
      {
        accessor: 'oem_model',
        Header: t('axis.oem_model'),
      },
      {
        columns: [{
          accessor: 'any_state',
          Header: t('axis.any_state'),
        }, {
          accessor: 'provisioned_devices',
          Header: t('axis.provisioned_devices'),
        }, {
          accessor: 'activated_devices',
          Header: t('axis.activated_devices'),
        }, {
          accessor: 'active_devices',
          Header: t('axis.active_devices'),
        },
        ],
        Header: 'Device Count',
      },
      {
        columns: [{
          accessor: 'total_transmissions',
          Header: t('axis.total_transmissions'),
        }, {
          accessor: 'total_avg',
          Header: t('axis.total_avg'),
        }, {
          accessor: 'total_reg',
          Header: t('axis.total_reg'),
        }, {
          accessor: 'total_unreg',
          Header: t('axis.total_unreg'),
        },
        ],
        Header: 'Number of Transmissions',
      }];

    return (
      <div className="DeviceUsageAnalysisPage page">
        <TitleBar title="deviceUsageAnalysis">
          <TimeAggregation fetchData={fetchData}
            value={this.props.presistFilters.aggregate_by}
          />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              sw_version(this.report(listOfSwVersions)),
            ]}
          />

          <div className="container-flex avgDisplay">
            <MultivalueDisplay title="averageDailyTransmissionByDevice"
              data={averageDailyTransmissionByDevice}
            />
          </div>
          <div>
            <TableReport title="dailyTransmissionsByDevice"
              columns={columnHead}
              data={average_daily_usage_by_device}
              description={this.reportDescription(dailyTransmissionsByDevice)}
              width={this.widthForColumns(1)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(DeviceUsageAnalysisPage);
